import { useMemo } from 'react'

export const useQueryParams = () => {
  const { search } = window.location;
  return useMemo(() => ({ params: new URLSearchParams(search.replace(/&amp;/g, '&')) }), [search])
}
